import { useState, useEffect } from 'react';
import HelperDate from '../../helpers/HelperDate';

interface ITimeLeft {
    days: number;
    hours: number;
    minutes: number;
}

interface IProps {
    targetDate: Date;
    title: string;
}

const Countdown = ({ targetDate, title }: IProps) => {
    const [timeLeft, setTimeLeft] = useState<ITimeLeft>({ days: 0, hours: 0, minutes: 0 });

    useEffect(() => {
        const calculateTimeLeft = (): ITimeLeft => {
            const difference = HelperDate.getDiff(new Date(), targetDate);

            if (difference > 0) {
                const days = Math.floor(difference / (1000 * 60 * 60 * 24));
                const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes = Math.floor((difference / 1000 / 60) % 60);

                return { days, hours, minutes };
            } else {
                return { days: 0, hours: 0, minutes: 0 };
            }
        };

        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 10000);

        setTimeLeft(calculateTimeLeft());

        return () => clearInterval(timer);
    }, [targetDate]);

    const formatNumber = (num: number): string => {
        return num.toString().padStart(2, '0');
    };

    return (
        <div className="card rounded-4">
            <div className="card-header gradient-green text-center text-uppercase rounded-top-4">
                <h4 className="m-0 text-white fs-3 fw-bold">{title}</h4>
            </div>
            <div className="card-body d-flex justify-content-center gap-4">
                <div className="d-flex flex-column text-center">
                    <span className="lh-1 fw-bold p-2 rounded text-white" style={{ backgroundColor: 'var(--green-dark)', fontSize: '2rem' }}>
                        {formatNumber(timeLeft.days)}
                    </span>
                    <span className="fs-5">dias</span>
                </div>
                <div className="d-flex flex-column text-center">
                    <span className="lh-1 fw-bold p-2 rounded text-white" style={{ backgroundColor: 'var(--green-dark)', fontSize: '2rem' }}>
                        {formatNumber(timeLeft.hours)}
                    </span>
                    <span className="fs-5">horas</span>
                </div>
                <div className="d-flex flex-column text-center">
                    <span className="lh-1 fw-bold p-2 rounded text-white" style={{ backgroundColor: 'var(--green-dark)', fontSize: '2rem' }}>
                        {formatNumber(timeLeft.minutes)}
                    </span>
                    <span className="fs-5">minutos</span>
                </div>
            </div>
        </div>
    );
};

export default Countdown;